export const initialAvatarClasses = `
    rounded
    rounded-full
    w-[40px]
    h-[40px]
    md:w-[60px]
    md:h-[60px]
`
